import type {
  AttributesEntity,
  ValuesEntity,
} from '@eliadmin/core/src/api/products/types/product-types';
import { Label } from '@eliadmin/core/src/components/ui/label';
import { useCategoryStore } from '@eliadmin/core/src/stores/category-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';

export function AttributeColor({
  attribute,
  updateVariantValues,
  className = '',
}: {
  attribute: AttributesEntity;
  updateVariantValues: (attribute: AttributesEntity, value: ValuesEntity) => void;
  className?: string;
}) {
  const attrId = attribute.id;
  const filter = useCategoryStore(state => state.filter.attributes);
  const valueAttribute = filter.find(item => item.id === attrId);
  const setFilter = useCategoryStore(state => state.setFilter);

  const sortedValues = [...(attribute.values ?? [])].sort(
    (a, b) => (a.position ?? 0) - (b.position ?? 0),
  );

  return (
    <div className={cn('flex w-full flex-col space-y-2', 'ea-attribute-color', className)}>
      {sortedValues.map(value => {
        const isActive = valueAttribute?.values.includes(value.id);

        return (
          <div
            key={`attribute-${attribute.id}-value-${value.id}`}
            className={cn(
              'flex flex-row items-center justify-start gap-2',
              'ea-attribute-color__wrapper',
            )}
          >
            <div
              onClick={() => {
                setFilter({ selectedValue: { attribute, value } });
                updateVariantValues(attribute, value);
              }}
              className={cn(
                'relative h-[23px] w-[23px] cursor-pointer rounded-full border-[3px] border-input',
                'ea-attribute-color__content',
                { 'border-primary': isActive },
              )}
              style={{ backgroundColor: value.color! }}
            ></div>
            <Label
              htmlFor={`attribute-${attribute.id}-value-${value.id}`}
              className={cn('text-sm font-normal lg:text-base', 'ea-attribute-color__label', {
                'font-semibold': isActive,
              })}
            >
              {value.name}
            </Label>
          </div>
        );
      })}
    </div>
  );
}
